import React from 'react';
import Card, {CardActions} from 'material-ui/Card';

import RaisedButton from 'material-ui/RaisedButton';
import Input from '../components/Forms/Input.jsx';
import AuthStore from '../reflux/stores/AuthStore';
import AuthActions from '../reflux/AuthActions';
import AlertActions from '../reflux/AlertActions';

export default class Correlativos extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            proxima_ret_iva:'',
            proxima_ret_renta: '',
        };

        this.handleAuthChange = this.handleAuthChange.bind(this);
    }
    
    componentWillMount() {
        AlertActions.configureAppBar('Numeración', null, null);
        AuthActions.checkLogin();
    }
    
    componentDidMount() {
        this.unsubscribe = AuthStore.listen(this.handleAuthChange);
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    handleAuthChange(e, data) {
        if (e === 'auth_success') {
            const correlativos = data.cliente.correlativos;

            this.setState({
                proxima_ret_iva: correlativos.proxima_ret_iva,
                proxima_ret_renta: correlativos.proxima_ret_renta
            });
        }

        if (e === 'correlativos_updated') {
            this.setState({
                proxima_ret_iva: data.proxima_ret_iva,
                proxima_ret_renta: data.proxima_ret_renta
            });
        }
    }

    
    
    render() {
        return (
            <div className="retivacontainer" style={{marginTop:35}}>
                <Card style={{padding:20, marginBottom: 10}}>
                    <Input 
                        name="proxima_ret_iva"
                        validations="required,number"
                        floatingLabelText="Proxima Retención de I.V.A."
                        val={this.state.proxima_ret_iva}
                        onChange={(e) => this.setState({proxima_ret_iva: e.target.value})}
                        debounce={0}
                        fullWidth={true}
                        />

                    <Input 
                        name="proxima_ret_renta"
                        validations="required,number"
                        floatingLabelText="Proxima Retención de I.S.L.R."
                        val={this.state.proxima_ret_renta}
                        onChange={(e) => this.setState({proxima_ret_renta: e.target.value})}
                        debounce={0}
                        fullWidth={true}
                        />
                        
                        <CardActions style={{marginTop:20}}>
                            <RaisedButton
                                style={{width:'100%'}} 
                                label="Actualizar"
                                primary={true}
                                fullWidth={true}
                                onTouchTap={() => AuthActions.updateCorrelativos(this.state)} />
                        </CardActions>
                </Card>
                
            </div>
            );
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/pages/Correlativos.jsx
 **/